// TODO (later,nice-to-have) make VE/TW reusable solution for displayCss (hideOn, showOn)
interface BreadProps {
  path: string;
  outerDisplayCss?: string;
  logoDisplayCss?: string;
}

const Bread = ({ path, outerDisplayCss = "", logoDisplayCss = "" }: BreadProps) => {
  const mainBrandNode = (
    <a href="/" aria-label="Home">
      <img
        className={logoDisplayCss}
        src="/shared-assets/branding/icon-180x180.png"
        alt=""
        width={24}
        height={24}
        loading="lazy"
      />
    </a>
  );

  return (
    <div className={`${outerDisplayCss} flex items-center gap-1`}>
      {mainBrandNode}
      <svg className={`w-6 h-6 opacity-50`} aria-hidden="true">
        <use xlinkHref={`/shared-assets/images/icons.svg#slash`} />
      </svg>
      <span aria-current="true">{path}</span>
    </div>
  );
};

export default Bread;
